import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!

  return (_openBlock(), _createElementBlock("div", null, [
    _renderSlot(_ctx.$slots, "default", {
      statusOk: _ctx.mtaeStatusOk,
      mtaeProof: _ctx.mtaeProof
    }, () => [
      _createVNode(_component_v_btn_icon, {
        disabled: !_ctx.mtaeStatusOk,
        onClick: _withModifiers(_ctx.mtaeProof, ["stop"]),
        size: "small",
        icon: "$oss-download"
      }, null, 8, ["disabled", "onClick"])
    ])
  ]))
}